/**
 * Genera un enlace de WhatsApp limpio y codificado de forma segura.
 * @param {string|number} numero - Número con indicativo (ej: "573161585420")
 * @param {string} mensaje - Texto plano que recibirá el asesor
 * @returns {string} URL lista para el atributo href
 */
export const constructorWhatsapp = (numero, mensaje) => {
  // 1. Limpieza total del número (quita espacios, letras, guiones o símbolos +)
  const numeroLimpio = numero ? String(numero).replace(/[^0-9]/g, '') : "573161585420";

  // 2. Codificación web segura (convierte espacios a %20, saltos de línea, etc.)
  const mensajeCodificado = mensaje ? encodeURIComponent(mensaje) : "";

  // 3. Retorna únicamente la cadena de texto
  return `https://wa.me/${numeroLimpio}?text=${mensajeCodificado}`;
};